export default __webpack_public_path__ + "static/media/typeS_high.9e56e877.png";